import React from 'react'

import { notification } from 'antd'
import { mapStateToProps, mapDispatchToProps, connect } from '../../reducers/Dispatchers'

const DEFAULT_ERROR_MESSAGE = 'An unknown error has occured.'
const ERRORS = {
  400: 'Access denied.',
  401: 'Wrong credentials.',
  403: 'You do not have the right to access or edit this data.',
  404: 'This ressource cannot be found.',
  405: 'This is not allowed.',
  408: 'The server does not answer.',
  409: 'Conflict saving data.',
  410: 'Entity is deleted.',
  500: 'Internal Server Error'
}

class ApiErrorCatcher extends React.Component {
  state = {
    errors: [],
    defaultErrorMessage: DEFAULT_ERROR_MESSAGE
  }

  componentDidMount () {
    const props = this.props
    this.updateErrors(props)

    document.addEventListener('api-error', this.handleApiError, false)
    document.addEventListener('api-message', this.handleApiMessage, false)
    document.addEventListener('api-error-displayer', this.handleApiErrorDisplayer, false)
  }

  componentWillUnmount () {
    document.removeEventListener('api-error', this.handleApiError, false)
    document.removeEventListener('api-message', this.handleApiMessage, false)
    document.removeEventListener('api-error-displayer', this.handleApiErrorDisplayer, false)
  }

  /**
   * @deprecated used "api-error-displayer" event instead
   */
  handleApiError = (apiError) => {
    let errorMessage = this.state.defaultErrorMessage
    const error = ERRORS[apiError.detail.code]

    if (error) {
      errorMessage = this.props.t(error)
    }

    const errorObject = {
      message: errorMessage,
      placement: 'bottomRight'
    }

    if (apiError.detail.errorDetails) {
      errorObject.description = this.props.t(apiError.detail.errorDetails)
    }

    notification.error(errorObject)
  }

  handleApiMessage = (apiMessage) => {
    const messageObject = {
      message: this.props.t(apiMessage.detail.title),
      placement: 'bottomRight',
      description: this.props.t('Data not saved. ')
    }

    if (apiMessage.detail.message.forEach) {
      apiMessage.detail.message.forEach(messagePart => {
        messageObject.description += this.props.t(messagePart)
      })
    } else {
      messageObject.description = apiMessage.detail.message
    }

    notification.warning(messageObject)
  }

  handleApiErrorDisplayer = (apiError) => {
    const apiResponse = apiError.detail

    const status = apiResponse?.status || 'Unknown'
    const statusText = apiResponse?.statusText || 'Unknown Error'
    const errorMessage = ERRORS[status] || DEFAULT_ERROR_MESSAGE

    const messageObject = {
      message: status + ' : ' + this.props.t(statusText),
      placement: 'bottomRight',
      description: this.props.t(errorMessage)
    }

    notification.error(messageObject)
  }

  componentDidUpdate (nextProps) {
    if (this.props.t(DEFAULT_ERROR_MESSAGE) !== nextProps.t(DEFAULT_ERROR_MESSAGE)) {
      this.updateErrors(nextProps)
    }
  }

  updateErrors = (props) => {
    // Translations are get with an async load to server, and are missing when this component mounted.
    // This is why this function is used for : reload errors translations.

    const errors = Object.keys(ERRORS).map(code => ({ code, message: this.props.t(ERRORS[code]) }))

    this.setState({
      errors: errors,
      defaultErrorMessage: props.t(DEFAULT_ERROR_MESSAGE)
    })
  }

  render () { return null }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApiErrorCatcher)
